import { ContinuingEducationCourse } from './continuingEducationCourse'
import { FeathersModel } from './feathersModel'
import { User } from './user'
import { Assistant } from './assistant'
import { OaCoordinator } from './oaCoordinator'
import { Contract } from './contract'

export class Worker extends FeathersModel {
  static serviceName = 'workers'
  userId: string
  contracts: Contract[] = []
  hasTrainingAsWorkerInSocialServices: boolean
  hasTrainingAsSocialWorker: boolean
  user: User
  assistant?: Assistant
  oaCoordinator?: OaCoordinator

  continuingEducationCourses: ContinuingEducationCourse[]

  turnSubresourcesIntoFrontendModels() {
    this.user = this.user ? User.createFromProps(User, this.user) : this.user

    if (this.contracts && this.contracts.length > 0) {
      const tempc = []
      for (const c of this.contracts) {
        tempc.push(Contract.createFromProps(Contract, c))
      }
      this.contracts = tempc

      const activeContract = Contract.computeCurrentlyActiveContract(this.contracts)
      if (activeContract) {
        this.contracts.find((c) => activeContract.id === c.id).currentlyActive = true
      }
    }
  }

  removeContract(id: number) {
    this.contracts = this.contracts.filter((c: Contract) => c.id !== id)
  }
}
